import { AnyAction } from 'redux';
import { call, put, takeEvery } from 'redux-saga/effects';

import { getMetaForDocumentId } from 'api/api';
import {
  fetchDocumentMetaErrorAction,
  fetchDocumentMetaStartAction,
  fetchDocumentMetaSuccessAction,
} from 'actions/documentMeta';
import { GET_DOCUMENT_META } from 'actions/documentMeta/types';
import { fetchDocumentFile } from 'sagas/documentFile';

export function* fetchDocumentMeta({ documentId, documentVersion }: AnyAction) {
  try {
    yield put(fetchDocumentMetaStartAction());
    const { data: documentMeta } = yield call(
      getMetaForDocumentId,
      documentId,
      documentVersion,
      document.location.host
    );

    yield call(fetchDocumentFile, documentMeta.url);

    yield put(fetchDocumentMetaSuccessAction(documentMeta));
  } catch (e) {
    console.error(e);
    yield put(
      fetchDocumentMetaErrorAction(
        e.response?.status,
        e.response?.data?.message
      )
    );
  }
}

export default function* watchFetchDocumentMeta() {
  yield takeEvery(GET_DOCUMENT_META, fetchDocumentMeta);
}
